import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        /*let $filters = '';

        document.addEventListener('facetwp-loaded', function() {
            let $dropdowns  = $('.facetwp-facet .fs-dropdown .fs-options');
            let $clearAll = '<div class="fs-option g0 d0" data-value="clear" data-idx="0" tabindex="-1"><span class="fs-checkbox"><i></i></span><div class="fs-option-label">Clear</div></div>';
            $dropdowns.prepend($clearAll);
        });*/


    }
}